import { voiceSchema, type UpdateVoiceRequest, type Voice } from '@gb-ticket/shared-types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api';
import { meQueryKey } from '@/platform/auth/use-me';
import { publicBrandQueryKey } from '@/platform/brand/use-public-brand';
import { notificationsQueryKey } from '@/features/notifications/use-notifications';

export const voiceQueryKey = ['voice'] as const;

export function useVoiceSettings(enabled: boolean) {
  return useQuery({
    queryKey: voiceQueryKey,
    queryFn: () => apiFetch('/voice', voiceSchema),
    enabled,
  });
}

export function useUpdateVoiceSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateVoiceRequest) =>
      apiFetch('/voice', voiceSchema, { method: 'PATCH', body: JSON.stringify(body) }),
    onSuccess: (voice: Voice) => {
      queryClient.setQueryData(voiceQueryKey, voice);
      queryClient.setQueryData(
        meQueryKey,
        (current: { addressForm?: string } | null | undefined) =>
          current ? { ...current, ...voice } : current,
      );
      queryClient.setQueryData(publicBrandQueryKey, (current: object | undefined) =>
        current ? { ...current, ...voice } : current,
      );
      void queryClient.invalidateQueries({ queryKey: notificationsQueryKey });
    },
  });
}
